<template>
  <div class="w-full h-full custom-content-publi" :class="{ 'mt-0': isDesktop }">
    <div class="notebook">
      <div class="lock">
        <template v-if="!canDisplayOnMobileIOS">
          <div class="title-banner subs">{{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Exclusive_Subscribers }}</div>
          <div class="subtitle-banner subs">{{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Sign_Up_access }}</div>
          <vs-button class="btn-register-lock" @click.stop="$emit('open-plans')">{{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Register }}</vs-button>
        </template>
        <template v-else>
          <div class="title-banner demo">{{ $t('PRIVATE_CONTENT').Exclusive_Subscribers }}</div>
          <div class="subtitle-banner demo">{{ $t('PRIVATE_CONTENTUSERDEMO').IOS_Text }}</div>
          <vs-button class="btn-register-lock" @click.stop="$emit('open-attendance')">{{ $t('PRIVATE_CONTENTUSERDEMO').Attendance }}</vs-button>
        </template>
      </div>
    </div>
    <div class="smart">
      <ul class="smartContent">
        <h2 class="mb-5 title-ben">{{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Smart_Content_Title }}</h2>
        <li>🔎 {{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Smart_Content_L1 }}</li>
        <li>💰 {{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Smart_Content_L2 }}</li>
        <li>📊 {{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Smart_Content_L3 }}</li>
        <li>🌎 {{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Smart_Content_L4 }}</li>
        <li>📈 {{ $t('PRIVATE_CONTENTUSERSUBSCRIBER').Smart_Content_L5 }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isDesktop: {
      require: true
    },
    displayCloseBtn: {
    default: true
    }
  },
  data() {
    return {
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3,
          swipeEasing: true
        },
    };
  },
  watch: {
  },
  computed: {
    canDisplayOnMobileIOS() {
      return this.$store.state.isMobileIOS;
    },
    contentPrivate() {
      return this.$store.state.contentPrivate || {text: ''};
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-8 w-8";
      } else {
        return "h-6 w-6";
      }
    },
  },
  methods: {
  }
};

</script>

